export class SipMessageBus {
  private events: Record<string, ((data: Record<string, unknown>) => void)[]> = {};
  private returnSource = '';
  private returnOrigin = '';

  constructor() {
    window.addEventListener('message', (event: MessageEvent) => {
      if (!event.data || !event.data.source) return;
      if (event.data.source.includes('angular')) return;
      if (event.data.source.includes('piral')) return;
      if (event.data.source === 'neodymium') {
        this.returnOrigin = event.data.returnOrigin;
        this.returnSource = event.data.returnSource;
        if (event.data.selfClosing) {
          window.onblur = () => {
            const message = { source: this.returnSource, success: false, error: 'window_closed' };
            window.opener.postMessage(message, this.returnOrigin);
            window.close();
          };
        }
        window.opener.postMessage({ source: `neodymium_${this.returnSource}` }, this.returnOrigin);
        return;
      }
      this.handleReceivedMessage(event.data.source, event.data);
    });
  }

  public on(source: string, listener: (data: Record<string, unknown>) => void) {
    if (!this.events[source]) {
      this.events[source] = [];
    }
    this.events[source].push(listener);
  }

  public off(source: string, listenerToRemove: (data: Record<string, unknown>) => void) {
    if (!this.events[source]) {
      return;
    }
    this.events[source] = this.events[source].filter(listener => listener !== listenerToRemove);
    if (this.events[source].length === 0) {
      delete this.events[source];
    }
  }

  public once(source: string, listener: (data: Record<string, unknown>) => void): () => void {
    const remover = (data: Record<string, unknown>) => {
      listener(data);
      this.off(source, remover);
    };
    this.on(source, remover);
    return () => this.off(source, remover);
  }

  public handleReceivedMessage(source: string, data: Record<string, unknown>) {
    if (!this.events[source]) {
      return;
    }
    this.events[source].forEach(listener => listener(data));
  }

  public postMessage(data: Record<string, unknown>) {
    const dest = window.opener ? window.opener : window;
    const message = { source: this.returnSource, success: true, data };
    dest.postMessage(message, this.returnOrigin);
  }
}
